import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import BarChartIcon from "@mui/icons-material/BarChart";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import VideoCameraFrontIcon from "@mui/icons-material/VideoCameraFront";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { SidebarCol } from "../../screens/chatMain/Sidebar/Sidebar.jsx";
import { MainHeader } from "../../screens/chatMain/MainHeader/MainHeader.jsx";

const DEV_MENU_ITEMS = [
  {
    label: "Assessment Analytics",
    description: "View and analyse assessment data",
    icon: BarChartIcon,
    path: "/assessment-analytics",
    iconColor: "#4F46E5",
    bgColor: "#EEF2FF",
  },
  {
    label: "Add Bulk Data",
    description: "Upload CSV or Excel data in bulk",
    icon: UploadFileIcon,
    path: "/dev/addData",
    iconColor: "#0891B2",
    bgColor: "#ECFEFF",
  },
  {
    label: "Live Events",
    description: "Create, edit, manage sessions & attendees",
    icon: VideoCameraFrontIcon,
    path: "/dev/live-events",
    iconColor: "#059669",
    bgColor: "#ECFDF5",
  },
  {
    label: "Send Email",
    description: "Broadcast rich custom emails to organizations or users",
    icon: MailOutlineIcon,
    path: "/dev/send-email",
    iconColor: "#D97706",
    bgColor: "#FEF3C7",
    hidden: true, // Hidden for now as requested
  },
];

const DevIndex = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        width: "100vw",
        height: "100vh",
        maxWidth: "100vw",
        maxHeight: "100vh",
        overflow: "hidden",
        background: "#F8FAFC",
      }}
    >
      {/* Sidebar */}
      <Box sx={{ flexShrink: 0 }}>
        <SidebarCol />
      </Box>

      {/* Main area */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <MainHeader
          titleText="Developer Portal"
          subtitleText="Expand Your Insight"
        />

        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            px: 3,
            pb: 4,
            pt: 3,
          }}
        >
          {/* Breadcrumb */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 4 }}>
            <Typography variant="caption" sx={{ color: "#9ca3af" }}>
              Home
            </Typography>
            <Typography variant="caption" sx={{ color: "#9ca3af" }}>
              /
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "#374151", fontWeight: 500 }}
            >
              Developer
            </Typography>
          </Box>

          {/* Navigation cards */}
          <Grid container spacing={3} justifyContent="center">
            {DEV_MENU_ITEMS.filter((item) => !item.hidden).map((item, _, arr) => {
              const IconComponent = item.icon;
              return (
                <Grid item xs={12} sm={6} md={arr.length <= 3 ? 4 : 3} key={item.label}>
                  <Card
                    sx={{
                      borderRadius: 3,
                      boxShadow: "0px 2px 12px rgba(0,0,0,0.08)",
                      transition: "transform 0.15s ease, box-shadow 0.15s ease",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        boxShadow: "0px 8px 24px rgba(0,0,0,0.14)",
                      },
                    }}
                  >
                    <CardActionArea
                      onClick={() => navigate(item.path)}
                      sx={{ p: 1 }}
                    >
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 2,
                          py: 4,
                        }}
                      >
                        <Box
                          sx={{
                            width: 72,
                            height: 72,
                            borderRadius: "50%",
                            bgcolor: item.bgColor,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <IconComponent
                            sx={{ fontSize: 36, color: item.iconColor }}
                          />
                        </Box>
                        <Box sx={{ textAlign: "center" }}>
                          <Typography variant="h6" fontWeight={600}>
                            {item.label}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mt: 0.5 }}
                          >
                            {item.description}
                          </Typography>
                        </Box>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default DevIndex;
